export const contentId = "cks63jaef04xo2emnjywe6dw2";
export const assignmentMemberMockup = {
  content: {
    slug: "religion-philosophy-1",
    activities: [
      {
        id: 1,
        activityType: "quiz",
        name: "Quiz",
        subject: "ELA",
        text: "some instructions...",
        collection: 339,
      },
      {
        id: 2,
        activityType: "write",
        name: "Write Prompt",
        subject: "Science",
        text: "some prompt...",
        collection: 389,
      },
      {
        id: 3,
        activityType: "lesson-sparks",
        name: "Spark Words",
        subject: "ELA",
        text: "some words...",
        collection: 339,
      },
    ],
  },
  display_order: 0,
};
